import { SportTypes } from '../types';

export const TWO_TEAMS_SPORTS = [
  SportTypes.FOOTBALL,
  SportTypes.BASKETBALL,
  SportTypes.HANDBALL,
  SportTypes.ICE_HOCKEY,
  SportTypes.ROLLER_HOCKEY,
  SportTypes.RUGBY_LEAGUE,
  SportTypes.CRICKET,
];

export const RACING_SPORTS = [SportTypes.CYCLING, SportTypes.MOTORSPORTS];
